const uz = {
    meta: {
        title: "Tayyor CRM yoki o'z CRM — 36 oylik hisob | Innobek",
        description:
            "amoCRM va Bitrix24 abonent to'lovi vs o'z CRM: 5, 15 va 30 kishilik jamoa uchun 36 oylik TCO jadvali, break-even nuqtasi va tayyor CRM qachon yaxshiroq.",
        keywords: [
            "tayyor CRM yoki individual CRM",
            "amoCRM alternativa O'zbekiston",
            "Bitrix24 abonent to'lovi qancha",
            "CRM narxi Toshkent",
            "CRM tanlash mezonlari",
            "CRM TCO hisobi",
        ],
    },
    h1: "amoCRM va Bitrix24 abonent to'lovi vs o'z CRM: uch yillik hisob-kitob",
    lead:
        "Tayyor CRM har oy to'lanadi, o'z CRM bir marta. Qaysi biri arzon tushishi jamoa hajmiga bog'liq — va chegara siz o'ylagan joyda emas. Quyida 36 oylik ochiq jadval, kesishish nuqtalari va tayyor CRM afzal bo'ladigan holatlar.",
    category: "Avtomatlashtirish",
    readingTime: "10 daqiqa",

    body: [
        {
            type: "p",
            text:
                "«Tayyor CRM arzonroq» degan fikr birinchi oyda to'g'ri, uchinchi yilda esa ko'pincha noto'g'ri bo'lib chiqadi. Lekin teskarisi ham har doim to'g'ri emas: ba'zi jamoa uchun tayyor tizim uch yildan keyin ham arzonroq qoladi. Farq nimada ekanini raqam bilan ko'rib chiqamiz.",
        },

        { type: "h2", text: "Ikki to'lov modeli o'rtasidagi asosiy farq" },
        {
            type: "p",
            text:
                "Tayyor CRM — ijara. Siz litsenziyaga obuna bo'lasiz va tizim sizniki bo'lmaydi. To'lovni to'xtatsangiz, ertaga kirish yopiladi. Ma'lumotni eksport qilib olasiz, lekin ishlaydigan tizim qolmaydi.",
        },
        {
            type: "p",
            text:
                "O'z CRM — aktiv. Bir marta to'laysiz, kod va ma'lumotlar bazasi sizda qoladi, foydalanuvchi soni uchun qo'shimcha haq yo'q. Buning evaziga boshlang'ich summa katta va javobgarlik ham sizda: server, yangilanish, o'zgarishlar.",
        },
        {
            type: "p",
            text:
                "Qaysi model arzonroq — bu matematika masalasi, e'tiqod masalasi emas. Hisobni to'g'ri qilish uchun uchta parametr kerak: jamoa hajmi, muddat va obuna modeli. Uchinchisi eng ko'p e'tibordan chetda qoladi, chunki amoCRM va Bitrix24 mutlaqo boshqacha hisoblaydi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "amoCRM va Bitrix24 2026-yilda qancha turadi?" },
        {
            type: "p",
            text:
                "Quyidagi raqamlar 2026-yil sentyabr holatida rasmiy sayt tariflaridan olingan. Tarif tez-tez o'zgaradi — buyurtma berishdan oldin joriy tarifni rasmiy saytdan tekshiring, chunki hamkor orqali va uzoq muddatga to'langanda narx pastroq bo'lishi mumkin.",
        },
        {
            type: "table",
            head: ["Tizim", "Tarif", "Narx", "Nimaga bog'langan"],
            rows: [
                ["Kommo (amoCRM xalqaro)", "Base", "$25 / foydalanuvchi / oy", "Har bir foydalanuvchi alohida"],
                ["Kommo", "Advanced", "$35 / foydalanuvchi / oy", "Har bir foydalanuvchi alohida"],
                ["Kommo", "Pro", "$45 / foydalanuvchi / oy", "Har bir foydalanuvchi alohida"],
                ["Bitrix24", "Basic", "$49 / oy, yillik to'lovda", "5 foydalanuvchigacha, butun akkaunt"],
                ["Bitrix24", "Standard", "$99 / oy, yillik to'lovda", "50 foydalanuvchigacha, butun akkaunt"],
                ["Bitrix24", "Professional", "$199 / oy, yillik to'lovda", "100 foydalanuvchigacha, butun akkaunt"],
                ["Innobek CRM", "Start / Business", "18 / 38 mln so'm, bir martalik", "Foydalanuvchi soniga bog'liq emas"],
            ],
        },
        {
            type: "callout",
            text:
                "Eng muhim nuqta shu jadvalda yashiringan: Kommo har bir foydalanuvchidan oladi, Bitrix24 esa butun akkaunt uchun qat'iy summa oladi. Jamoa o'sganda birinchisining hisobi chiziqli o'sadi, ikkinchisiniki esa keyingi tarif chegarasigacha umuman o'zgarmaydi.",
        },
        {
            type: "p",
            text:
                "Yana ikkita shart bor. Kommo va amoCRM da oylik to'lov yo'q — minimal obuna muddati olti oy. Rubl hududidagi amoCRM tariflari alohida: Bazaviy 599, Kengaytirilgan 1 299, Professional 1 799 rubl bir foydalanuvchi uchun oyiga. Quyidagi hisobda dollar tariflari va Markaziy bankning 2026-yil sentyabridagi kursi — 1 dollar taxminan 11 800 so'm — ishlatilgan.",
        },

        { type: "h2", text: "O'z CRM 36 oyda qancha turadi?" },
        {
            type: "p",
            text:
                "Innobek tariflari bir martalik: Start 18 mln so'mdan, muddati 5–8 hafta; Business 38 mln so'mdan, muddati 10–16 hafta. Ikkalasida ham olti oylik texnik qo'llab-quvvatlash narxga kiritilgan va foydalanuvchi soni uchun qo'shimcha haq olinmaydi.",
        },
        {
            type: "p",
            text:
                "Bir martalik summadan tashqari ikkita band bor. Birinchisi — server yoki bulut, odatda oyiga 300 ming so'mdan, to'g'ridan-to'g'ri provayderga to'lanadi. Ikkinchisi — olti oy tugagandan keyingi qo'llab-quvvatlash: doimiy shartnoma oyiga 3 500 000 so'mdan boshlanadi. Bu ikkinchi band ixtiyoriy, shuning uchun quyida ikkala variantni ham ko'rsatamiz.",
        },

        { type: "h2", text: "36 oylik jadval: 5, 15 va 30 kishilik jamoa" },
        {
            type: "p",
            text:
                "Jadvalda uch yillik jami xarajat. Kommo uchun Advanced tarifi, Bitrix24 uchun yillik to'lov bilan mos tarif olingan. Innobek ustunlarida ishlab chiqish va 36 oylik server to'lovi hisobga olingan.",
        },
        {
            type: "table",
            head: [
                "Jamoa",
                "Kommo Advanced",
                "Bitrix24, yillik",
                "O'z CRM, shartnomasiz",
                "O'z CRM, qo'llab-quvvatlash bilan",
            ],
            rows: [
                ["5 kishi", "~74 mln so'm", "~21 mln so'm (Basic)", "~29 mln so'm (Start)", "~134 mln so'm"],
                ["15 kishi", "~223 mln so'm", "~42 mln so'm (Standard)", "~49 mln so'm (Business)", "~154 mln so'm"],
                ["30 kishi", "~446 mln so'm", "~42 mln so'm (Standard)", "~49 mln so'm (Business)", "~154 mln so'm"],
            ],
        },
        {
            type: "p",
            text:
                "Hisob qanday chiqqanini ko'rsatib qo'yamiz, siz o'z raqamlaringizni qo'ya olishingiz uchun. 15 kishilik jamoa uchun Kommo: 15 × 35 dollar × 36 oy = 18 900 dollar, ya'ni taxminan 223 mln so'm. Bitrix24 Standard: 99 dollar × 36 oy = 3 564 dollar, taxminan 42 mln so'm. O'z CRM Business: 38 mln + 300 ming × 36 oy = taxminan 49 mln so'm.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Break-even qayerda — kesishish nuqtalari" },
        {
            type: "p",
            text:
                "Break-even — o'z tizimga sarflangan pul obuna to'loviga nisbatan qaytib bo'lgan oy. Uni hisoblash uchun bir martalik summani oylik farqqa bo'lasiz. Natijalar quyidagicha.",
        },
        {
            type: "list",
            items: [
                "Kommo Advanced, 5 kishi: obuna oyiga ~2 065 000 so'm. Start tarifi 18 mln ÷ (2 065 000 − 300 000) ≈ 10 oy.",
                "Kommo Advanced, 15 kishi: obuna ~6 195 000 so'm. Business tarifi 38 mln ÷ 5 895 000 ≈ 6,5 oy.",
                "Kommo Advanced, 30 kishi: obuna ~12 390 000 so'm. Business tarifi 38 mln ÷ 12 090 000 ≈ 3 oy.",
                "Bitrix24 Standard, 15 va 30 kishi: obuna ~1 168 000 so'm. Business tarifi 38 mln ÷ 868 000 ≈ 44 oy — uch yilga sig'maydi.",
                "Bitrix24 Basic, 5 kishi: obuna ~578 000 so'm. Start tarifi 18 mln ÷ 278 000 ≈ 65 oy — besh yildan ko'p.",
            ],
        },
        {
            type: "p",
            text:
                "Xulosa ochiq va u ba'zilarga kutilmagan tuyuladi. Foydalanuvchi soniga bog'langan obunada (Kommo, amoCRM) o'z tizim 3–10 oyda o'zini oqlaydi. Akkaunt uchun qat'iy summa oladigan Bitrix24 bilan esa faqat litsenziya hisobida o'z tizimni ortda qoldirib bo'lmaydi — uning litsenziyasi juda arzon. Bitrix24 dan chiqishning sababi narx emas, boshqa narsa bo'ladi.",
        },

        { type: "h2", text: "Tayyor CRM qachon yaxshiroq tanlov?" },
        {
            type: "p",
            text:
                "Bu bo'limni aynan biz yozayotganimiz g'alati tuyulishi mumkin, lekin noto'g'ri qaror ikki tomonga ham qimmatga tushadi. Quyidagi holatlarda tayyor tizimni olganingiz ma'qul.",
        },
        {
            type: "list",
            items: [
                "Jamoa kichik va o'sish rejasi yo'q. 3–7 kishi uchun obuna hech qachon sezilarli summaga aylanmaydi.",
                "Jarayon standart. Lid keldi — qo'ng'iroq — taklif — bitim. Bu qolip bozor yechimlarida allaqachon bor.",
                "Ertaga ishga tushishi kerak. Tayyor tizim bir kunda ochiladi, ishlab chiqish esa 5–16 hafta oladi.",
                "Byudjet hozir cheklangan. Oyiga 600 ming so'm topish 18 mln topishdan osonroq.",
                "Hali sinab ko'rmoqchisiz. CRM umuman ishlaydimi degan savol turgan bo'lsa, tayyor tizimda tekshirib ko'ring.",
            ],
        },
        {
            type: "p",
            text:
                "Bunda tayyor CRM bilan boshlab, keyin o'tish mutlaqo normal yo'l. Amaliyotimizda kompaniyalarning katta qismi aynan shunday keladi: bir-ikki yil tayyor tizimda ishlab, jarayonni yaxshi tushunib olgach, o'z yechimiga o'tadi. Bunday mijoz bilan ishlash osonroq, chunki u nima kerakligini aniq biladi.",
        },

        { type: "h2", text: "O'z CRM qachon mantiqiy bo'ladi?" },
        {
            type: "p",
            text:
                "Aksincha, quyidagi belgilardan ikkitasi to'g'ri kelsa, o'z tizim haqida jiddiy o'ylash kerak.",
        },
        {
            type: "ol",
            items: [
                "Foydalanuvchi soni 15 dan oshgan va o'sib bormoqda — obuna chizig'i tez ko'tariladi.",
                "Jarayon standart emas: o'z bosqichlaringiz, o'z hisob-kitobingiz, o'z tasdiqlash tartibingiz bor.",
                "Integratsiya chuqur: 1C, ombor, ishlab chiqarish yoki telefoniya bilan ikki tomonlama almashinuv kerak.",
                "Ma'lumot egaligi muhim: baza o'z serveringizda turishi talab qilinadi.",
                "Tayyor tizimda «bunday qilib bo'lmaydi» degan javobni yiliga bir necha marta eshityapsiz.",
            ],
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Jadvalga kirmagan xarajatlar" },
        {
            type: "p",
            text:
                "Yuqoridagi jadvalda faqat litsenziya va ishlab chiqish bor. Ikkala yo'lda ham hisobga olinmagan bandlar mavjud va ular qarorni o'zgartirishi mumkin.",
        },
        {
            type: "list",
            items: [
                "Moslashtirish. Tayyor tizimni jarayoningizga sozlash integrator bilan alohida kelishiladi va litsenziya to'lovidan mustaqil.",
                "Integratsiya. 1C, telefoniya va to'lov tizimiga ulanish ikkala variantda ham alohida ish.",
                "Migratsiya. Eski bazani ko'chirish va tozalash — odatda loyihaning eng ko'p vaqt oladigan qismi.",
                "O'qitish. Yangi tizim eski usuldan tez bo'lmasa, jamoa Excel'ga qaytadi.",
                "Qonun talablari. Markirovka va elektron hisob-faktura bilan ishlash tayyor tizimda ham qo'shimcha sozlashni talab qiladi.",
            ],
        },
        {
            type: "p",
            text:
                "Oxirgi band 2026-yilda alohida ahamiyat kasb etdi. PP-190 bo'yicha 1-iyuldan markirovka kodi chekda aks etishi shart, ulgurjida hisob-kitob faqat naqdsiz. Elektron hisob-faktura ustidan avtomatik nazorat ham kuchaytirilgan. Tizimni tanlashdan oldin u shu talablarni qanday yopishini so'rab oling.",
        },

        { type: "h2", text: "O'z CRM ning xavflari" },
        {
            type: "p",
            text:
                "Halol bo'lish uchun teskari tomonini ham aytamiz. O'z tizim uchta jiddiy xavf keltiradi.",
        },
        {
            type: "list",
            items: [
                "Ishlab chiquvchiga bog'liqlik. Shartnomada kod, hujjat va bazaga to'liq huquq sizga o'tishini yozdiring.",
                "Muddat. 5–16 hafta davomida jamoa eski usulda ishlaydi va bu vaqtda hech narsa yaxshilanmaydi.",
                "Yangilanish javobgarligi. Tayyor tizimda yangi funksiya o'zi paydo bo'ladi, o'z tizimda esa har o'zgarish alohida ish.",
            ],
        },
        {
            type: "p",
            text:
                "Shu uchta xavfni qabul qila olsangiz va jamoangiz 15 kishidan oshgan bo'lsa, hisob o'z tizim foydasiga ishlaydi. Qabul qila olmasangiz — tayyor tizimda qoling, bu ham to'liq asosli qaror.",
        },
        { type: "image", image: 3 },
    ],

    faq: [
        {
            q: "amoCRM va Bitrix24 dan qaysi biri arzonroq?",
            a: "Jamoa hajmiga bog'liq. Kommo va amoCRM har bir foydalanuvchidan oladi, Bitrix24 esa butun akkaunt uchun qat'iy summa oladi. 30 kishilik jamoada farq keskin: Kommo Advanced uch yilda taxminan 446 mln so'm, Bitrix24 Standard esa taxminan 42 mln so'm. Kichik jamoada farq deyarli sezilmaydi. Joriy tarifni rasmiy saytdan tekshiring.",
        },
        {
            q: "O'z CRM qachon o'zini oqlaydi?",
            a: "Foydalanuvchiga bog'langan obunaga nisbatan tez: 5 kishilik jamoada taxminan 10 oy, 15 kishida 6–7 oy, 30 kishida 3 oy atrofida. Bitrix24 ning qat'iy tarifiga nisbatan esa faqat litsenziya hisobida uch yilda o'zini oqlamaydi. Shuning uchun Bitrix24 dan o'tishning sababi narx emas, jarayon va integratsiya cheklovlari bo'ladi.",
        },
        {
            q: "Innobek CRM narxiga nima kiradi?",
            a: "Start tarifi 18 mln so'mdan: jarayon tahlili, voronka, mijozlar bazasi, bitimlar, vazifalar, sayt va Telegram'dan lid qabul qilish, asosiy hisobotlar, Excel'dan ko'chirish, o'qitish va olti oylik qo'llab-quvvatlash. Business 38 mln so'mdan: ombor, hujjatlar, moliya bloki, 1C integratsiyasi va telefoniya qo'shiladi. Server narxga kirmaydi.",
        },
        {
            q: "Tayyor CRM dan o'z tizimga ma'lumotni ko'chirib bo'ladimi?",
            a: "Ha. Kommo, amoCRM va Bitrix24 mijozlar, bitimlar va aloqa tarixini eksport qilish imkonini beradi. Amalda qiyinchilik faylni olishda emas, ma'lumotni tozalashda: takroriy yozuvlar, bo'sh maydonlar va nomuvofiq formatlar. Shu sababli migratsiyani alohida bosqich sifatida rejalashtiring va eski bazaga bir-ikki hafta ajrating.",
        },
        {
            q: "Kichik jamoaga o'z CRM kerakmi?",
            a: "Odatda yo'q. Uch-yetti kishilik jamoada obuna to'lovi sezilarli summaga aylanmaydi, tayyor tizim esa bir kunda ishga tushadi. O'z tizim haqida o'ylash uchun kamida ikkita shart kerak: foydalanuvchi soni o'sib borishi va jarayonning bozor qolipiga sig'masligi. Ikkalasi ham bo'lmasa, pulni marketingga sarflagan foydaliroq.",
        },
        {
            q: "O'z CRM dan keyin qo'llab-quvvatlash majburiymi?",
            a: "Yo'q, u ixtiyoriy. Narxga olti oylik texnik qo'llab-quvvatlash kiritilgan, shundan keyin doimiy shartnoma oyiga 3 500 000 so'mdan hisoblanadi. Amaliyotimizda ko'p kompaniya bu shartnomasiz ishlaydi va faqat o'zgarish yoki yangi modul kerak bo'lganda murojaat qiladi. Jadvaldagi ikkita oxirgi ustun aynan shu ikki stsenariyni yonma-yon ko'rsatadi.",
        },
    ],

    cta: {
        h: "O'z jamoangiz uchun hisobni birga qilamiz",
        p:
            "Foydalanuvchi soni, jarayon va integratsiyalar ro'yxatini aytsangiz, uch yillik xarajatni ikkala variant uchun ham hisoblab beramiz. Tayyor CRM sizga foydaliroq bo'lsa, buni ochiq aytamiz.",
        button: "Hisobni so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/crm-tco-obuna-va-bir-martalik.webp",
            alt: "Takrorlanuvchi obuna to'lovi va bir martalik shartnoma o'rtasidagi qarama-qarshilik",
            caption: "Ijara va aktiv: ikki to'lov modeli o'rtasidagi asosiy farq",
            prompt:
                "Split-screen conceptual image: left a recurring subscription invoice repeating into the distance like a corridor of identical bills; right a single one-time contract document with a key on top; clean editorial flat-vector, blue and amber, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/crm-tco-36-oy-grafik.webp",
            alt: "36 oy davomida jamlangan xarajat grafigi — obuna chiziqlari va individual tizim",
            caption: "Kesishish nuqtasi jamoa hajmiga qarab 3 oydan 5 yilgacha suriladi",
            prompt:
                "Cumulative cost line chart over 36 months: three subscription lines for teams of 5, 15 and 30 users rising linearly, and one flat step line for custom development starting higher then plateauing, with crossing points marked; clean analytics style, blue/teal/amber, month axis, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/family-group.webp",
            alt: "Family Group — mijozlar bazasi va savdo voronkasi menejerlar kesimida ko'rsatilgan",
            caption: "Family Group: individual CRM amalda qanday ko'rinadi",
        },
        {
            src: "/assets/img/blog/crm-tanlov-matritsasi.webp",
            alt: "Tayyor CRM va individual tizim o'rtasida tanlov matritsasi jadvali",
            caption: "Tanlov matritsasi: jamoa hajmi, jarayon, integratsiya va ma'lumot egaligi",
            prompt:
                "Decision matrix table illustration: rows for team size, process standardness, integration depth, data ownership; two columns marked with check or cross indicating ready-made CRM versus custom build; clean light table UI, green and grey, no readable text, 4:3",
        },
    ],

    relatedServices: ["crm-tizimlar", "erp-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: [
        "biznes-avtomatlashtirish-yol-xaritasi",
        "excel-dan-erp-ga-otish-signallari",
        "telegram-bot-nimani-avtomatlashtiradi",
    ],
};

const ru = {
    meta: {
        title: "Готовая CRM или своя: расчёт на 36 месяцев | Innobek",
        description:
            "Абонплата amoCRM и Битрикс24 против своей CRM: таблица TCO на 36 месяцев для команд в 5, 15 и 30 человек, точки окупаемости и когда готовая CRM выгоднее.",
        keywords: [
            "готовая CRM или своя разработка что дешевле",
            "альтернатива amoCRM Ташкент",
            "стоимость Битрикс24 для команды",
            "разработка CRM цена Узбекистан",
            "TCO CRM за три года",
            "как выбрать CRM для компании",
        ],
    },
    h1: "Абонплата amoCRM и Битрикс24 против своей CRM: расчёт на три года",
    lead:
        "Готовая CRM оплачивается каждый месяц, своя — один раз. Что дешевле, зависит от размера команды, и граница проходит не там, где обычно думают. Ниже открытая таблица на 36 месяцев, точки окупаемости и случаи, когда готовая система выигрывает.",
    category: "Автоматизация",
    readingTime: "10 минут",

    body: [
        {
            type: "p",
            text:
                "Утверждение «готовая CRM дешевле» верно в первый месяц и часто неверно на третий год. Но обратное тоже не универсально: для части команд подписка остаётся выгоднее даже спустя три года. Разберём, в чём именно разница, на цифрах.",
        },

        { type: "h2", text: "Чем принципиально отличаются две модели оплаты" },
        {
            type: "p",
            text:
                "Готовая CRM — это аренда. Вы подписываетесь на лицензию, система вам не принадлежит. Прекратили платить — доступ закрывается на следующий день. Данные выгрузить можно, а работающая система у вас не остаётся.",
        },
        {
            type: "p",
            text:
                "Своя CRM — это актив. Платите один раз, код и база остаются у вас, доплаты за количество пользователей нет. Взамен стартовая сумма выше, и ответственность тоже ваша: сервер, обновления, доработки.",
        },
        {
            type: "p",
            text:
                "Что дешевле — вопрос арифметики, а не убеждений. Для верного расчёта нужны три параметра: размер команды, горизонт и модель подписки. Третий чаще всего упускают, а зря: amoCRM и Битрикс24 считают деньги совершенно по-разному.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Сколько стоят amoCRM и Битрикс24 в 2026 году?" },
        {
            type: "p",
            text:
                "Цифры ниже взяты с официальных страниц тарифов по состоянию на сентябрь 2026 года. Тарифы меняются часто — перед покупкой сверьтесь с официальным сайтом: через партнёра и при оплате на длительный срок цена бывает ниже.",
        },
        {
            type: "table",
            head: ["Система", "Тариф", "Цена", "К чему привязана"],
            rows: [
                ["Kommo (amoCRM за рубежом)", "Base", "$25 / пользователь / мес.", "За каждого пользователя"],
                ["Kommo", "Advanced", "$35 / пользователь / мес.", "За каждого пользователя"],
                ["Kommo", "Pro", "$45 / пользователь / мес.", "За каждого пользователя"],
                ["Битрикс24", "Базовый", "$49 / мес. при оплате за год", "До 5 пользователей, на весь аккаунт"],
                ["Битрикс24", "Стандартный", "$99 / мес. при оплате за год", "До 50 пользователей, на весь аккаунт"],
                ["Битрикс24", "Профессиональный", "$199 / мес. при оплате за год", "До 100 пользователей, на весь аккаунт"],
                ["Innobek CRM", "Start / Business", "18 / 38 млн сум, разово", "От числа пользователей не зависит"],
            ],
        },
        {
            type: "callout",
            text:
                "Главное спрятано именно в этой таблице: Kommo берёт за каждого пользователя, а Битрикс24 — фиксированную сумму за весь аккаунт. При росте команды счёт первого растёт линейно, а счёт второго не меняется до следующей границы тарифа.",
        },
        {
            type: "p",
            text:
                "Есть два дополнительных условия. У Kommo и amoCRM нет помесячной оплаты — минимальный период подписки шесть месяцев. Рублёвые тарифы amoCRM отдельные: Базовый 599, Расширенный 1 299, Профессиональный 1 799 рублей за пользователя в месяц. В расчётах ниже используются долларовые тарифы и курс Центрального банка на сентябрь 2026 года — примерно 11 800 сум за доллар.",
        },

        { type: "h2", text: "Во сколько обходится своя CRM за 36 месяцев?" },
        {
            type: "p",
            text:
                "Тарифы Innobek разовые: Start от 18 млн сум, срок 5–8 недель; Business от 38 млн сум, срок 10–16 недель. В оба тарифа входит шесть месяцев технической поддержки, а доплаты за количество пользователей нет.",
        },
        {
            type: "p",
            text:
                "Кроме разовой суммы есть две статьи. Первая — сервер или облако, обычно от 300 тысяч сум в месяц, оплачивается напрямую провайдеру. Вторая — поддержка после шести бесплатных месяцев: постоянный договор стоит от 3 500 000 сум в месяц. Вторая статья необязательна, поэтому ниже показаны оба варианта.",
        },

        { type: "h2", text: "Таблица на 36 месяцев: команды в 5, 15 и 30 человек" },
        {
            type: "p",
            text:
                "В таблице суммарные расходы за три года. Для Kommo взят тариф Advanced, для Битрикс24 — подходящий тариф при оплате за год. В колонках Innobek учтены разработка и 36 месяцев сервера.",
        },
        {
            type: "table",
            head: [
                "Команда",
                "Kommo Advanced",
                "Битрикс24, за год",
                "Своя CRM, без договора",
                "Своя CRM, с поддержкой",
            ],
            rows: [
                ["5 человек", "~74 млн сум", "~21 млн (Базовый)", "~29 млн (Start)", "~134 млн сум"],
                ["15 человек", "~223 млн сум", "~42 млн (Стандартный)", "~49 млн (Business)", "~154 млн сум"],
                ["30 человек", "~446 млн сум", "~42 млн (Стандартный)", "~49 млн (Business)", "~154 млн сум"],
            ],
        },
        {
            type: "p",
            text:
                "Покажем, как получились цифры, чтобы вы могли подставить свои. Команда 15 человек, Kommo: 15 × 35 долларов × 36 месяцев = 18 900 долларов, около 223 млн сум. Битрикс24 Стандартный: 99 долларов × 36 месяцев = 3 564 доллара, около 42 млн сум. Своя CRM Business: 38 млн + 300 тысяч × 36 месяцев = примерно 49 млн сум.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Где проходит точка окупаемости?" },
        {
            type: "p",
            text:
                "Точка окупаемости — месяц, в котором вложения в свою систему сравниваются с накопленной подпиской. Считается делением разовой суммы на месячную разницу. Результаты такие.",
        },
        {
            type: "list",
            items: [
                "Kommo Advanced, 5 человек: подписка около 2 065 000 сум в месяц. Start: 18 млн ÷ (2 065 000 − 300 000) ≈ 10 месяцев.",
                "Kommo Advanced, 15 человек: подписка около 6 195 000 сум. Business: 38 млн ÷ 5 895 000 ≈ 6,5 месяца.",
                "Kommo Advanced, 30 человек: подписка около 12 390 000 сум. Business: 38 млн ÷ 12 090 000 ≈ 3 месяца.",
                "Битрикс24 Стандартный, 15 и 30 человек: подписка около 1 168 000 сум. Business: 38 млн ÷ 868 000 ≈ 44 месяца — за три года не окупается.",
                "Битрикс24 Базовый, 5 человек: подписка около 578 000 сум. Start: 18 млн ÷ 278 000 ≈ 65 месяцев, то есть больше пяти лет.",
            ],
        },
        {
            type: "p",
            text:
                "Вывод прямой, и для части читателей он неожиданный. Против подписки за каждого пользователя своя система окупается за 3–10 месяцев. Против фиксированного тарифа Битрикс24 по одной лишь лицензии обогнать готовое решение невозможно — оно слишком дёшево. Причина ухода с Битрикс24 всегда другая, не цена лицензии.",
        },

        { type: "h2", text: "Когда готовая CRM — лучший выбор?" },
        {
            type: "p",
            text:
                "Странно читать такой раздел в блоге разработчика, но неверное решение дорого обходится обеим сторонам. В перечисленных ситуациях берите готовую систему.",
        },
        {
            type: "list",
            items: [
                "Команда небольшая и планов роста нет. Для 3–7 человек подписка никогда не станет заметной суммой.",
                "Процесс стандартный: лид — звонок — предложение — сделка. Этот шаблон уже реализован в коробке.",
                "Запуск нужен завтра. Готовая система открывается за день, разработка занимает 5–16 недель.",
                "Бюджет сейчас ограничен. Найти 600 тысяч сум в месяц проще, чем 18 млн сразу.",
                "Вы ещё проверяете гипотезу. Если непонятно, приживётся ли CRM вообще, проверьте это на готовой.",
            ],
        },
        {
            type: "p",
            text:
                "Начать с готовой CRM и перейти позже — совершенно нормальный путь. В нашей практике большинство компаний приходит именно так: год-два работают в коробке, разбираются в собственном процессе и только потом заказывают своё. С таким заказчиком работать проще, потому что он точно знает, что ему нужно.",
        },

        { type: "h2", text: "Когда своя CRM оправдана?" },
        {
            type: "p",
            text:
                "Обратная ситуация: если совпадают хотя бы два признака из списка, о своей системе стоит подумать всерьёз.",
        },
        {
            type: "ol",
            items: [
                "Пользователей больше пятнадцати и число растёт — линия подписки идёт вверх быстро.",
                "Процесс нестандартный: свои этапы, своя логика расчётов, свой порядок согласования.",
                "Нужна глубокая интеграция: двусторонний обмен с 1С, складом, производством или телефонией.",
                "Важно владение данными: база должна находиться на вашем сервере.",
                "В готовой системе вы несколько раз в год слышите ответ «так сделать нельзя».",
            ],
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Расходы, которых нет в таблице" },
        {
            type: "p",
            text:
                "В таблице выше только лицензия и разработка. В обоих вариантах есть статьи, которые в неё не попали, и они способны изменить решение.",
        },
        {
            type: "list",
            items: [
                "Настройка. Подгонка готовой системы под ваш процесс согласовывается с интегратором отдельно и не связана с ценой лицензии.",
                "Интеграции. Подключение 1С, телефонии и платёжной системы — отдельная работа в обоих случаях.",
                "Миграция. Перенос и чистка старой базы обычно занимают больше всего времени в проекте.",
                "Обучение. Если новая система не быстрее прежнего способа, команда вернётся в Excel.",
                "Требования законодательства. Работа с маркировкой и электронными счетами-фактурами требует донастройки и в коробочной системе.",
            ],
        },
        {
            type: "p",
            text:
                "Последний пункт в 2026 году стал особенно весомым. По ПП-190 с 1 июля код маркировки обязан отображаться в чеке, а расчёты в опте идут только безналично. Автоматический контроль электронных счетов-фактур тоже усилен. Перед выбором системы спросите, как именно она закрывает эти требования.",
        },

        { type: "h2", text: "Риски собственной разработки" },
        {
            type: "p",
            text:
                "Честности ради назовём и обратную сторону. Своя система несёт три ощутимых риска.",
        },
        {
            type: "list",
            items: [
                "Зависимость от подрядчика. Пропишите в договоре, что код, документация и база полностью передаются вам.",
                "Срок. В течение 5–16 недель команда работает по-старому, и в это время ничего не улучшается.",
                "Ответственность за развитие. В коробке новые функции появляются сами, в своей системе каждое изменение — отдельная работа.",
            ],
        },
        {
            type: "p",
            text:
                "Если эти три риска для вас приемлемы, а команда перевалила за пятнадцать человек, арифметика работает в пользу своей системы. Если неприемлемы — оставайтесь на готовой, это тоже полностью обоснованное решение.",
        },
        { type: "image", image: 3 },
    ],

    faq: [
        {
            q: "Что дешевле — amoCRM или Битрикс24?",
            a: "Зависит от размера команды. Kommo и amoCRM берут плату за каждого пользователя, Битрикс24 — фиксированную сумму за весь аккаунт. На тридцати сотрудниках разница резкая: Kommo Advanced обойдётся примерно в 446 млн сум за три года, Битрикс24 Стандартный — около 42 млн. На маленькой команде разница почти незаметна. Актуальные тарифы сверяйте на официальном сайте.",
        },
        {
            q: "За какой срок окупается своя CRM?",
            a: "Против подписки за каждого пользователя быстро: примерно за 10 месяцев на команде из пяти человек, за 6–7 месяцев на пятнадцати и около трёх месяцев на тридцати. Против фиксированного тарифа Битрикс24 по одной лицензии за три года окупаемости не наступает. Поэтому причиной перехода с Битрикс24 становится не цена, а ограничения процесса и интеграций.",
        },
        {
            q: "Что входит в стоимость CRM от Innobek?",
            a: "Тариф Start от 18 млн сум: анализ процесса, воронка, база клиентов, сделки, задачи, приём лидов с сайта и из Telegram, базовые отчёты, перенос из Excel, обучение и шесть месяцев поддержки. Business от 38 млн сум добавляет склад, документы, финансовый блок, двустороннюю интеграцию с 1С и телефонию. Сервер в стоимость не входит.",
        },
        {
            q: "Можно ли перенести данные из готовой CRM в свою?",
            a: "Да. Kommo, amoCRM и Битрикс24 позволяют выгрузить клиентов, сделки и историю коммуникаций. Сложность обычно не в получении файла, а в чистке данных: дубли, пустые поля, несогласованные форматы. Поэтому планируйте миграцию как отдельный этап и закладывайте на старую базу одну-две недели работы.",
        },
        {
            q: "Нужна ли своя CRM небольшой команде?",
            a: "Как правило, нет. При трёх-семи сотрудниках подписка не превращается в заметную сумму, а готовая система запускается за день. Чтобы думать о своей разработке, нужны минимум два условия: растущее число пользователей и процесс, который не укладывается в коробочный шаблон. Без них деньги полезнее направить в маркетинг.",
        },
        {
            q: "Обязательна ли поддержка после запуска своей CRM?",
            a: "Нет, она добровольная. В стоимость входит шесть месяцев технической поддержки, после чего постоянный договор стоит от 3 500 000 сум в месяц. Многие компании работают без договора и обращаются только под конкретные доработки. Две последние колонки таблицы показывают именно эти два сценария.",
        },
    ],

    cta: {
        h: "Посчитаем цифры для вашей команды",
        p:
            "Расскажите про процесс, число пользователей и нужные интеграции — посчитаем трёхлетние расходы для обоих вариантов. Если готовая CRM окажется для вас выгоднее, скажем об этом прямо.",
        button: "Запросить расчёт",
    },

    images: [
        {
            src: "/assets/img/blog/crm-tco-obuna-va-bir-martalik.webp",
            alt: "Противопоставление повторяющейся подписки и разового платежа за систему",
            caption: "Аренда против актива: ключевое различие двух моделей оплаты",
            prompt:
                "Split-screen conceptual image: left a recurring subscription invoice repeating into the distance like a corridor of identical bills; right a single one-time contract document with a key on top; clean editorial flat-vector, blue and amber, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/crm-tco-36-oy-grafik.webp",
            alt: "График накопленных расходов за 36 месяцев — линии подписки и своя система",
            caption: "Точка пересечения сдвигается от 3 месяцев до пяти лет",
            prompt:
                "Cumulative cost line chart over 36 months: three subscription lines for teams of 5, 15 and 30 users rising linearly, and one flat step line for custom development starting higher then plateauing, with crossing points marked; clean analytics style, blue/teal/amber, month axis, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/family-group.webp",
            alt: "Family Group — база клиентов и воронка продаж в разрезе менеджеров",
            caption: "Family Group: как собственная CRM выглядит на практике",
        },
        {
            src: "/assets/img/blog/crm-tanlov-matritsasi.webp",
            alt: "Матрица выбора между готовой CRM и собственной разработкой",
            caption: "Матрица выбора: размер команды, процесс, интеграции, владение данными",
            prompt:
                "Decision matrix table illustration: rows for team size, process standardness, integration depth, data ownership; two columns marked with check or cross indicating ready-made CRM versus custom build; clean light table UI, green and grey, no readable text, 4:3",
        },
    ],

    relatedServices: ["crm-tizimlar", "erp-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: [
        "biznes-avtomatlashtirish-yol-xaritasi",
        "excel-dan-erp-ga-otish-signallari",
        "telegram-bot-nimani-avtomatlashtiradi",
    ],
};

const content = { uz, ru };

export default content;
